module.exports = __webpack_public_path__ + "static/media/how-to-pick.2df63533.png";